import { Stack, Typography } from '@mui/material';

import { ChatDisclaimerTooltip } from '@/modules/common/Chat/components/ChatDisclaimerTooltip';

export function DocumentChatHeader() {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography variant="title-s">Chat</Typography>
      <ChatDisclaimerTooltip />
    </Stack>
  );
}
